// extracted by mini-css-extract-plugin
export default {"advertDetailParameterList":"c-p_fN","advertDetailParameterList__header":"c-p_fO","advertDetailParameterList__list":"c-p_fP"};